'use strict';

angular.module('magtac')
    .controller('ServerDeleteDetailsCtrl', [
        '$scope', '$stateParams', 'ServerDeleteDetailsViewModel',
        function ($scope, $stateParams, viewModel) {
            $scope.model = new viewModel($stateParams.companyCode);
        }
    ]);
